export const adaptGestionPresupuestos = (gestionPresupuestos, idEvaluacion) => {
    return {
        idEvaluacion: idEvaluacion,
        fechaEnvioPresupuesto: gestionPresupuestos?.fechaEnvioPresupuesto,
        idMedioEnvio: gestionPresupuestos?.idMedioEnvio,
        observacionPresupuesto: gestionPresupuestos?.observacion,
        idResultadoPresupuesto: gestionPresupuestos?.idResultadoPresupuesto,
        fechaResultadoPresupuesto: gestionPresupuestos?.fechaResultadoPresupuesto,
        numeroSeguimiento: gestionPresupuestos?.numeroSeguimiento,
        presupuestoAutorizado: gestionPresupuestos?.presupuestoAutorizado,
        transferenciaParticulares: gestionPresupuestos?.transferenciaParticulares
    }
}